<template>
  <footer id="footer-page">
    <v-row class="py-8 px-4 px-sm-8 text-white pb-0">
      <!-- Logotipos -->
      <v-col cols="12" sm="6" class="text-center text-sm-left">
        <img
          :src="require('../assets/logos/logo-cemiterio-previda-azul.png')"
          alt="Logo Grupo Parque"
          width="140"
          class="mr-2 mr-sm-6"
        />
        <img
          :src="require('../assets/logos/logo-grupo-parque-azul.png')"
          alt="Logo Previda"
          width="140"
        />
      </v-col>

      <v-col cols="12" sm="6" class="mt-4 mt-sm-0">
        <div class="social-icons d-flex justify-center justify-sm-end">
          <v-btn
            variant="text"
            elevation="0"
            href="https://api.whatsapp.com/send/?phone=558000091700&text&type=phone_number&app_absent=0"
            target="_blank"
          >
            <v-icon size="36" class="ml-4 ml-sm-8" color="var(--bg-secondary)"
              >mdi-whatsapp</v-icon
            >
          </v-btn>
          <v-btn
            variant="text"
            elevation="0"
            @click="openSocialDialog('instagram')"
          >
            <v-icon size="36" class="ml-4 ml-sm-8" color="var(--bg-secondary)"
              >mdi-instagram</v-icon
            >
          </v-btn>
          <v-btn
            variant="text"
            elevation="0"
            @click="openSocialDialog('facebook')"
          >
            <v-icon size="36" class="ml-4 ml-sm-8" color="var(--bg-secondary)"
              >mdi-facebook</v-icon
            >
          </v-btn>
        </div>
      </v-col>

      <!-- Links -->
      <v-col cols="12" sm="6" class="footer-links mt-6 mt-sm-0">
        <v-row>
          <v-col cols="6" sm="4" class="py-2">
            <a @click="$router.push('/sobrenos')">Sobre nós</a>
          </v-col>
          <v-col cols="6" sm="4" class="py-2">
            <a @click="$router.push('/servicos/arapiraca')"
              >Estrutura e Serviços - Arapiraca</a
            >
          </v-col>
          <v-col cols="6" sm="4" class="py-2">
            <a @click="$router.push('/servicos/saomiguel')"
              >Estrutura e Serviços - São Miguel</a
            >
          </v-col>
          <v-col cols="6" sm="4" class="py-2">
            <a @click="openDialog('plans')">Nossos planos</a>
          </v-col>
          <v-col cols="6" sm="4" class="py-2">
            <a
              href="https://velorios.gpdf.com.br/cemiterioprevida"
              target="_blank"
              >Nota de Falecimento</a
            >
          </v-col>
          <v-col cols="6" sm="4" class="py-2">
            <a href="#footer-page">Entre em contato</a>
          </v-col>
          <v-col cols="6" sm="4" class="py-2">
            <a href="tel:558000091700" target="_blank"
              >Atendimento 24h: <br />
              0800 009 1700</a
            >
          </v-col>
          <v-col cols="6" sm="4" class="py-2">
            <a href="https://jazigo.cemiterioprevida.com.br/" target="_blank"
              >Localize seu jazigo</a
            >
          </v-col>
          <v-col cols="6" sm="4" class="py-2">
            <a href="https://pagamento.cemiterioprevida.com.br/" target="_blank"
              >2ª Via do boleto</a
            >
          </v-col>
        </v-row>
      </v-col>

      <!-- Formulário de contato e redes -->
      <v-col cols="12" sm="6" class="mt-6 mt-sm-0">
        <v-card
          class="contact-box px-4 px-sm-6 py-6 py-sm-8"
          rounded="xl"
          elevation="4"
        >
          <v-card-subtitle
            class="px-0 mb-4 white--text text-center text-sm-left"
            style="opacity: 1"
          >
            Está com dúvidas? Deixe seus contatos. Falaremos em breve!
          </v-card-subtitle>

          <v-card-text class="pa-0">
            <!-- Campo de e-mail -->
            <v-text-field
              placeholder="E-mail:"
              density="compact"
              v-model="email"
              :rules="[validEmail]"
              variant="solo"
              hide-details
              bg-color="#cde8f8"
              class="mb-4"
              rounded="lg"
            />

            <!-- Campo de celular com botão embutido -->
            <v-row class="ma-0">
              <v-col cols="12" sm="8" class="pa-0 pr-sm-2">
                <v-text-field
                  v-mask="'(##) #####-####'"
                  v-model="celular"
                  placeholder="Celular"
                  density="compact"
                  variant="solo"
                  hide-details
                  bg-color="#cde8f8"
                  rounded="lg"
                />
              </v-col>

              <v-col cols="12" sm="4" class="pa-0">
                <v-btn
                  color="#0d2b51"
                  class="text-white mt-4 mt-sm-0"
                  style="text-transform: none !important"
                  @click="enviar"
                  block
                >
                  Cadastrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <!-- Copyright -->
        <v-row justify="center">
          <v-col cols="12" class="text-center py-8">
            <p class="direitos">
             © 2025 Cemitério Previda Todos os direitos reservados
            </p>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" class="pb-0">
        <section
          class="elementor-section elementor-top-section legal-links-section"
        >
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column"
            >
              <div class="elementor-widget-wrap">
                <div class="legal-links">
                  <a href="assets/politicas/POL0006R02_PP.pdf" target="_blank">
                    Política de Privacidade
                  </a>
                  <span>|</span>
                  <a href="assets/politicas/POL0007R01_PC.pdf" target="_blank">
                    Política de Cookies
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="600" class="pa-4">
      <v-card class="dialog-card">
        <v-card-title class="text-center pa-4">
          <span class="dialog-title">Escolha uma unidade</span>
        </v-card-title>
        <v-card-text class="pa-4 pa-sm-6 pt-0">
          <div class="cemiterios-grid">
            <v-btn
              class="cemiterio-btn"
              elevation="2"
              rounded="lg"
              @click="handleUnitClick('arapiraca')"
              style="text-transform: none !important"
            >
              <div class="cemiterio-content">
                <h3>Cemitério Previda</h3>
                <h4>Arapiraca</h4>
              </div>
            </v-btn>

            <v-btn
              class="cemiterio-btn"
              elevation="2"
              rounded="lg"
              @click="handleUnitClick('saomiguel')"
              style="text-transform: none !important"
            >
              <div class="cemiterio-content">
                <h3>Cemitério Previda</h3>
                <h4>São Miguel dos Campos</h4>
              </div>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </footer>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  data() {
    return {
      email: "",
      celular: "",
      dialog: false,
      currentAction: null, // 'social' ou 'plans'
      currentSocialNetwork: null,
      socialLinks: {
        arapiraca: {
          instagram: "https://www.instagram.com/cemiterioprevida/",
          facebook: "https://www.facebook.com/previdaarapiraca",
        },
        saomiguel: {
          instagram: "https://www.instagram.com/cemiterioprevidasmc/",
          facebook: "https://www.facebook.com/profile.php?id=61574680474256",
        },
      },
    };
  },
  methods: {
    validEmail(value) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(value) || "E-mail inválido";
    },
    enviar() {
      if (this.validEmail(this.email) !== true) {
        toast.error("E-mail inválido!");
        return;
      }
      if (!this.celular || this.celular.length < 15) {
        toast.error("Informe o celular!");
        return;
      }
      toast.warning("Em manutenção!");
    },
    openSocialDialog(network) {
      this.currentAction = "social";
      this.currentSocialNetwork = network;
      this.dialog = true;
    },
    openDialog(action) {
      this.currentAction = action;
      this.dialog = true;
    },
    handleUnitClick(unit) {
      if (this.currentAction === "social" && this.currentSocialNetwork) {
        window.open(
          this.socialLinks[unit][this.currentSocialNetwork],
          "_blank"
        );
      } else if (this.currentAction === "plans") {
        this.$router.push(`/planos/${unit}`);
      }
      this.dialog = false;
      this.currentAction = null;
      this.currentSocialNetwork = null;
    },
  },
};
</script>

<style scoped>
footer {
  background-color: var(--white-soft);
  min-height: 24rem;
}

.footer-links a {
  color: var(--bg-secondary);
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  display: inline-block;
  padding-bottom: 2px;
}

.v-icon:hover {
  opacity: 0.8;
}

.footer-links a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: var(--bg-secondary);
  transition: width 0.3s ease;
}

.footer-links a:hover::after {
  width: 100%;
}

@media (max-width: 600px) {
  .footer-links a {
    padding-bottom: 0;
  }

  .footer-links a::after {
    display: none;
  }
}

.contact-box {
  background: linear-gradient(to right, #00446d, #007cc7);
  color: white;
}

.social-icons v-icon {
  cursor: pointer;
}

.direitos {
  color: var(--bg-secondary);
}
/* Estilização do Dialog */
:deep(.dialog-card) {
  border-radius: 16px;
  overflow: hidden;
}

.dialog-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: var(--bg-primary);
}

@media (min-width: 600px) {
  .dialog-title {
    font-size: 1.8rem;
  }
}

.cemiterios-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 16px;
}

@media (min-width: 600px) {
  .cemiterios-grid {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 20px;
  }
}

.cemiterio-btn {
  height: auto !important;
  padding: 16px !important;
  background: white !important;
  border: 2px solid var(--bg-primary) !important;
  transition: all 0.3s ease;
}

@media (min-width: 600px) {
  .cemiterio-btn {
    padding: 24px !important;
  }
}

.cemiterio-content h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--bg-primary);
  margin-bottom: 4px;
}

.cemiterio-content h4 {
  font-size: 1rem;
  font-weight: 500;
  color: var(--bg-secondary);
  margin-bottom: 8px;
}

@media (min-width: 600px) {
  .cemiterio-content h3 {
    font-size: 1.4rem;
  }

  .cemiterio-content h4 {
    font-size: 1.2rem;
  }
}

.cemiterio-btn:hover {
  background: linear-gradient(
    to right,
    var(--bg-primary),
    var(--bg-secondary)
  ) !important;
  transform: translateY(-2px);
}

.cemiterio-btn:hover .cemiterio-content h3,
.cemiterio-btn:hover .cemiterio-content h4,
.cemiterio-btn:hover .cemiterio-content p {
  color: white !important;
}


/* Seção de Links Legais - LGPD */
.legal-links-section {
  background-color: var(--white-soft);
  padding: 10px 20px;
  border-top: 1px solid #e0e0e0;
}

.legal-links-section .elementor-container {
  max-width: 1200px;
  margin: 0 auto;
}

.legal-links-section .elementor-widget-wrap {
  text-align: center;
  padding: 0 20px;
}

.legal-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
}

.legal-links a {
  color: #666;
  text-decoration: none;
  font-size: 12px;
  font-weight: 400;
  transition: color 0.3s ease;
}

.legal-links a:hover {
  color: #315886;
}

.legal-links span {
  color: #ddd;
}
</style>
